import React from 'react';
import { Box, Text, HStack, Icongraphy } from '@design-system/pc';
import { ShopDetailReview } from '@remodeling/goods';
import useShopDetailCustomerReviewCard from './hooks/useShopDetailCustomerReviewCard';
import TrackingService from '@/services/tracking';

interface ShopDetailCustomerReviewCardProps {
  review: ShopDetailReview;
  tagName: string;
  tagValues?: any;
}

const ShopDetailCustomerReviewCard = ({
  review,
  tagName,
  tagValues,
}: ShopDetailCustomerReviewCardProps) => {
  const { isExpanded, handleClickExpanded } = useShopDetailCustomerReviewCard();

  return (
    <Box
      backgroundColor={isExpanded ? 'color_chip.gray.50' : 'color_chip.white'}
      minHeight="182px"
      height={isExpanded ? 'auto' : '182px'}
      overflow="hidden"
      style={{ cursor: 'pointer' }}
      border="1px solid"
      borderColor="color_chip.gray.200"
      borderRadius="2px"
      p={32}
      width="100%"
      onClick={handleClickExpanded}
      {...TrackingService.tagGTM(tagName, { ...tagValues })}
    >
      <HStack justifyContent="space-between">
        <HStack gap={4}>
          <HStack>
            {[...Array(5)].map((_, starIdx) => (
              <Icongraphy
                key={`rating-star-${starIdx}`}
                variant="ic_star_solid"
                size={18}
                resize
                fillColor={
                  starIdx < (review.agntEvalScore ?? 0) ? '#121212' : '#e2e2e2'
                }
              />
            ))}
          </HStack>
          <Text variant="headline7" color="color_chip.primary">
            {`${review.agntEvalScore}.0`}
          </Text>
        </HStack>
        <HStack>
          <Text variant="caption3" color="color_chip.gray.600">
            {review.custId}
          </Text>
          <Box
            width="1px"
            height="11px"
            backgroundColor="color_chip.gray.400"
            mx="8px"
          />
          <Text variant="caption3" color="color_chip.gray.600">
            {review.regYmdt}
          </Text>
        </HStack>
      </HStack>
      <Text
        variant="body1"
        color="color_chip.primary"
        mt="8px"
        style={{
          WebkitLineClamp: isExpanded ? 'unset' : 4,
          WebkitBoxOrient: 'vertical',
          display: '-webkit-box',
          overflow: 'hidden',
          wordBreak: 'break-all',
          lineHeight: '24px',
        }}
      >
        {review.agntEvalConts}
      </Text>
    </Box>
  );
};

export default ShopDetailCustomerReviewCard;
